import { CurrencyPipe } from '@angular/common';
import { Pipe } from '@angular/core';
import { isNil } from 'lodash';

@Pipe({
    name: 'yssCurrency',
})
export class YssCurrencyPipe extends CurrencyPipe {
    transform(
        value: number | string,
        currencyCode = 'GBP',
        display?: string | boolean,
        digitsInfo?: string,
        locale?: string
    ): any {
        if (isNil(value) || !this.isNumeric(value)) {
            return value;
        }
        return super.transform(value, currencyCode, display, digitsInfo, locale);
    }

    isNumeric(value: number | string): boolean {
        const v = value.toString();
        return !!v.trim().length && !isNaN(+v);
    }
}
